'use client';

import { Fullscreen } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
interface FullscreenDataTableProps {
  fullscreenDialogTitle: string;
  fullscreenDialogDescription?: string;
  fullscreenDialogContent: React.ReactNode;
}
export const DataTableActions = ({
  fullscreenDialogTitle,
  fullscreenDialogDescription,
  fullscreenDialogContent
}: FullscreenDataTableProps) => {
  return <Dialog>
      <div className="flex flex-col sm:flex-row p-5 w-full bg-white items-center gap-5">
        <span className="font-heading font-medium text-base text-secondary-readable">
          Actions
        </span>
        <DialogTrigger asChild className="inline-flex">
          <Button size="sm" variant="secondary">
            <Fullscreen /> Fullscreen
          </Button>
        </DialogTrigger>
      </div>
      <DialogContent variant="fullscreen" onPointerDownOutside={e => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>{fullscreenDialogTitle}</DialogTitle>
          {fullscreenDialogDescription && <DialogDescription>{fullscreenDialogDescription}</DialogDescription>}
        </DialogHeader>
        <div className="overflow-auto">{fullscreenDialogContent}</div>
      </DialogContent>
    </Dialog>;
};